<div class="grey-back">
    <div class="empty-header text-center">
        <img
            src="https://storage.googleapis.com/inapp-bucket/static%20images/in-white.png"
            alt=""
        />
    </div>
    <div class="padded-container response">
        <p>{{ paragraph_content | translate }}</p>
    </div>
</div>
